export default "__VITE_ASSET__C$1ByqIK__"